import { CognitoUtils } from '../../components/Utility/CognitoUtils';

import { PasswordResetInner } from './PasswordResetInner';

export interface IPasswordResetProps {
  appView?: boolean;
}

export const PasswordReset = ({ appView = false }: IPasswordResetProps) => (
  <CognitoUtils
    render={({ resetPassword }) => (
      <PasswordResetInner resetPassword={resetPassword} appView={appView} />
    )}
  />
);
